export const REMOVE_PRODUCT_FROM_SHOPPING_BASKET =
  'Remove product from shopping basket has failed';
export const ADD_PRODUCT_TO_SHOPPING_BASKET =
  'Add product to shopping basket has failed';
export const ADD_CONTACT_DETAILS_TO_SHOPPING_BASKET =
  'Add contact details to shopping basket has failed';
export const MISSING_PRODUCT_TYPE_SUMMARY_CONFIGURATION_ERROR = (productType) =>
  `Product type ${productType} is not defined in productsConfiguration`;
export const MISSING_BUNDLE_TYPE_SUMMARY_CONFIGURATION_ERROR = (bundleType) =>
  `Bundle type ${bundleType} is not defined in bundlesConfiguration`;
export const MISSING_SHOPPING_BASKET_ID_ERROR = 'Shopping basket id is null';
export const SHOPPING_BASKET_NOT_FOUND_ERROR =
  'The shopping basket is not available';
export const EMPTY_SHOPPING_BASKET_ERROR = 'Shopping basket is empty';
export const ON_REMOVE_PRODUCT_FROM_SHOPPING_BASKET_ERROR =
  'Error removing product';
export const ON_ADD_PRODUCT_TO_SHOPPING_BASKET_ERROR = 'Error adding product';
export const ON_ADD_CONTACT_TO_SHOPPING_BASKET_ERROR =
  'Error adding contact details';
export const MISSING_DYNAMIC_TEMPLATE_CONFIG_PER_PARAM_ERROR = (
  dynamicComponentId,
  paramId,
  configId
) =>
  `Dynamic component ${dynamicComponentId} config not found for paramId: ${paramId} and configId: ${configId}`;
